var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _round2 = _interopRequireDefault(require("lodash/round"));

var _Basic = require("../../../../elements/Basic");

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Basic/LoadingSpinner/index.js";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var LoadingSpinner = function (_React$Component) {
  (0, _inherits2.default)(LoadingSpinner, _React$Component);

  var _super = _createSuper(LoadingSpinner);

  function LoadingSpinner() {
    var _this;

    (0, _classCallCheck2.default)(this, LoadingSpinner);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.getRange = function (n) {
      return (0, _toConsumableArray2.default)(new Array(n).keys());
    };

    return _this;
  }

  (0, _createClass2.default)(LoadingSpinner, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          m = _this$props.m,
          width = _this$props.width,
          height = _this$props.height,
          position = _this$props.position,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["m", "width", "height", "position"]);
      var count = 12;
      var speed = 1.2;
      var circles = this.getRange(count).map(function (k) {
        var rotate = (0, _round2.default)(360 / count * (k + 1), 1);
        var delay = (0, _round2.default)(-speed + speed / count * k, 1);
        return React.createElement(_Basic.AnimatedCircle, {
          key: delay,
          delay: delay,
          rotate: rotate,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 31,
            columnNumber: 20
          }
        });
      });
      return React.createElement(_Basic.View, (0, _extends2.default)({
        m: m,
        width: width,
        height: height,
        position: position
      }, rest, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 34,
          columnNumber: 13
        }
      }), circles);
    }
  }]);
  return LoadingSpinner;
}(React.Component);

LoadingSpinner.propTypes = {
  m: _propTypes.default.string,
  width: _propTypes.default.number,
  height: _propTypes.default.number,
  position: _propTypes.default.string
};
LoadingSpinner.defaultProps = {
  m: '100px auto',
  width: 40,
  height: 40,
  position: 'relative'
};
var _default = LoadingSpinner;
exports.default = _default;